/** Axios extras so a request can target a workspace other than the active one. */
export function threadRequestConfig(options = {}) {
  const config = {}
  if (options.signal) config.signal = options.signal
  if (options.workspaceId) {
    config.headers = { 'X-Workspace-Id': options.workspaceId }
  }
  if (options.params && Object.keys(options.params).length) config.params = options.params
  return config
}
